import React, { useState, useMemo } from 'react';
import View from './view';
import CPPUtils from 'services/CPPUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import { setFormValues } from 'hooks/useReduxForm';

const DEFAULT_ARRAY: any[] = [];

const YellowCard = ({
  patient,
  onClose,
  hideTopBar = false,
}: {
  patient: any;
  onClose?: () => void;
  hideTopBar?: boolean;
}) => {
  const dispatch = useAppDispatch();

  const patientImmunizations =
    useAppSelector((state) => state.healthRecords.byId[patient.id]?.immunizations) || DEFAULT_ARRAY;
  const ownRole = useAppSelector((state) => state.authentication.role);

  const [showAllImmunizations, setShowAllImmunizations] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [collapsed, setCollapsed] = useState(true);

  const formName = CPPUtils.getFormName('immunizations', patient.id);

  const immunizations = useMemo(() => {
    if (showAllImmunizations) return patientImmunizations;
    return patientImmunizations.filter((immunization: any) => {
      return CPPUtils.isWithinOneYearImmunization(immunization);
    });
  }, [patientImmunizations, showAllImmunizations]);

  function resetForm() {
    onEdit({});
  }

  async function onGenerate() {
    setGenerating(true);
    await dispatch(api.HealthRecords.generateImmunizations({ patientId: patient.id }), {
      title: 'Generate Scheduled Immunizations',
      successText: 'Immunizations generated successfully!',
    });
    setGenerating(false);
  }

  function showAllButtonClicked() {
    setShowAllImmunizations(!showAllImmunizations);
  }

  function onEdit(immunization: any) {
    setCollapsed(false);
    dispatch(
      setFormValues({
        formName,
        values: CPPUtils.getImmunizationEditElement(immunization),
      }),
    );
  }

  async function onDelete(immunization: any) {
    await dispatch(
      api.HealthRecords.removeImmunization({ id: immunization.id, patientId: patient.id }),
    );
  }

  return (
    <View
      showAllImmunizations={showAllImmunizations}
      generating={generating}
      collapsed={collapsed}
      /*@ts-ignore*/
      ownRole={ownRole}
      showAllButtonClicked={showAllButtonClicked}
      patient={patient}
      immunizations={immunizations}
      onClose={onClose}
      onDelete={onDelete}
      onEdit={onEdit}
      onGenerate={onGenerate}
      resetForm={resetForm}
      form={formName}
      setCollapsed={setCollapsed}
      hideTopBar={hideTopBar}
    />
  );
};

export default YellowCard;
